import { SelectControl } from "@wordpress/components";
import { useState, useEffect, useRef } from "react";
import { __, sprintf } from "@wordpress/i18n";
const declOfNum = (number, titles) => {
    var cases = [2, 0, 1, 1, 1, 2];
    return (
      number +
      " " +
      titles[
        number % 100 > 4 && number % 100 < 20
          ? 2
          : cases[number % 10 < 5 ? number % 10 : 5]
      ]
    );
  };
  export {declOfNum};
const MethodDescription = (props) => {
  const { billing, monobank_data, eventRegistration, emitResponse } = props;
  const { onPaymentProcessing } = eventRegistration;
  const total = billing?.cartTotal?.value ?? 0;
  const currency = billing?.currency ?? {
    code: "UAH",
    symbol: "грн.",
    thousandSeparator: "",
    decimalSeparator: ".",
    minorUnit: 2,
    prefix: "",
    suffix: " грн.",
  };
// Начальное значение частей
const [selectedParts, setSelectedParts] = useState(3);
// const selectedPartsRef = useRef(selectedParts);
// Максимальное количество частей оплаты
const maxParts = monobank_data.partsCount || 10;
// useEffect(() => {
//   selectedPartsRef.current = selectedParts;
// }, [selectedParts]);
//   console.log(selectedPartsRef.current, selectedParts);
  
  // Функция форматирования суммы
  const formatAmount = (amount) => {
    return (
      currency.prefix +
      (amount / Math.pow(10, currency.minorUnit)).toFixed(currency.minorUnit) +
      currency.suffix
    );
  };

  // Опции для SelectControl
  const selectOptions = Array.from({ length: maxParts - 2 }, (_, i) => {
    const parts = i + 3;
    return {
      value: parts,
      label: sprintf(
        __("%s по %s", "themewoocommerce-monobank"),
        declOfNum(parts, [
          __("платеж", "themewoocommerce-monobank"),
          __("платежа", "themewoocommerce-monobank"),
          __("платежей", "themewoocommerce-monobank"),
        ]),
        formatAmount(total / parts)
      ),
    };
  });

  useEffect(() => {
    const unsubscribe = onPaymentProcessing(async () => {
      return {
        type: emitResponse.responseTypes.SUCCESS,
        meta: {
          paymentMethodData: {
            partforclientmono: String(selectedParts), // передача кастомных данных
          },
        },
      };
    });

    return () => {
      unsubscribe();
    };
  }, [selectedParts]);

  return (
    monobank_data.partforclientmono && maxParts > 3 && (<div className="method-description">
      {/* <p>{__("Выберите количество платежей:", "themewoocommerce-monobank")}</p> */}
      <SelectControl
        label={__("Выберите количество платежей", "themewoocommerce-monobank")}
        value={selectedParts}
        options={selectOptions}
        onChange={(value) => setSelectedParts(Number(value)) }
        variant="default"
        __nextHasNoMarginBottom={true}
      />
      <p>
        {sprintf(
          __("Вы платите: %s x %s", "themewoocommerce-monobank"),
          selectedParts,
          formatAmount(total / selectedParts)
        )}
      </p>
    </div>) || (<div>
      <p>{monobank_data.description}</p>
    </div>)
  );
};

export default MethodDescription;
